module.exports = __webpack_public_path__ + "media/coffee-preferences/main_flavor_chocolatey-b84bb794.png";